function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    id: "svg2157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 100.89298,527.7718 C 131.31929,454.85311 198.52168,394.45284 215.2521,317.19243 178.84904,236.41882 110.36456,168.26625 82.773667,77.600546 c 9.190226,-31.703341 76.972823,-4.066269 96.407083,2.589096 55.9258,26.243458 78.28307,91.706378 108.53248,141.158728 46.15331,-48.66811 76.8913,-170.725471 139.34273,-190.704732 26.31388,8.556766 111.27841,29.471064 85.28633,64.66349 -54.67891,70.068112 -105.90194,143.274402 -141.05106,223.833852 34.88074,75.13076 95.91447,136.94368 130.16177,217.4639 -1.7395,38.043 -75.92511,18.39563 -102.23898,9.83885 -39.31497,-37.40447 -61.63906,-89.20367 -99.87615,-126.48146 -42.06597,27.83922 -55.46314,146.47083 -104.98189,149.39283 -16.42176,0.25541 -88.39027,-38.25511 -94.00195,-41.64665",
    style: {
      fill: "#ff4e34",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedX);
export default __webpack_public_path__ + "static/media/redX.b15d6be1abb7e3cdb30c704eed96731f.svg";
export { ForwardRef as ReactComponent };